import qs from "qs";
import * as axiosHelper from "./api_helper";
import { clearTransferRequestKey } from "helpers/transferIdempotency";

export const fetchWalletsAPI = async ({ payload }) => {
  const result = await axiosHelper.get(`/wallets/?${qs.stringify(payload)}`);
  if (result.status)
    return result.result;
  else
    throw new Error(result.message);
};

export const createWalletTransferRequest = async({ payload }) => {
  const data = await axiosHelper.post("/wallet/transfer", payload);
  if (data?.status !== true || data?.isError) {
    if (data?.result?.state === "COMPENSATED") {
      try { clearTransferRequestKey(payload.idempotencyKey) } catch (error) { /* Keep a stored key if storage is unavailable. */ }
    }
    throw new Error(data?.message || "Unable to confirm transfer; retry with the same request");
  }
  try { clearTransferRequestKey(payload.idempotencyKey) } catch (error) { /* The confirmed transfer must still return success. */ }
  return data;
};

export const fetchReportsAPI = async (payload) => {
  const result = await axiosHelper.get(`/wallet/report/?${qs.stringify(payload)}`);
  if (result.status)
    return result.result;
  else
    throw new Error(result.message);
};

export const createIbWalletTransferAPI = async ({ payload }) => {
  const result = await axiosHelper.post("/ib-wallet/transfer", payload);
  if (result.isError) {
    throw new Error(result.message);
  } 
  return result;
};
